import { render, staticRenderFns } from "./CafeNotice.vue?vue&type=template&id=51cdfbd8&"
import script from "./CafeNotice.vue?vue&type=script&lang=js&"
export * from "./CafeNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('51cdfbd8', component.options)
    } else {
      api.reload('51cdfbd8', component.options)
    }
    module.hot.accept("./CafeNotice.vue?vue&type=template&id=51cdfbd8&", function () {
      api.rerender('51cdfbd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/CafeNotice.vue"
export default component.exports